module.exports = __webpack_public_path__ + "static/img/steam_icon.b96e44b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/steam_icon.png
// module id = QXC1
// module chunks = 0